<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-19 15:41:18
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-12-02 16:31:23
 * @Description: 查看物流
-->
<template>
  <div>
    <div class="title">
      <el-descriptions title="" :colon="false">
        <el-descriptions-item label="物流公司：">{{
          logisticsCompanyName || '-'
        }}</el-descriptions-item>
        <el-descriptions-item label="运单号：">{{
          logisticsNumber || '-'
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-if="list === null" class="no-data" v-loading="true"></div>
    <div class="list" v-if="list && list.length > 0">
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in list"
          :key="index"
          :type="index === 0 ? 'primary' : 'info'"
          :size="index === 0 ? 'large' : 'normal'"
          :timestamp="item.time"
        >
          {{ item.context }}
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="no-data" v-if="list && list.length === 0">
      暂无物流信息
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logisticsCompanyName: {
      type: String,
      default: ''
    },
    logisticsCompanyCode: {
      type: String,
      default: ''
    },
    logisticsNumber: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      list: null
    }
  },
  created () {
    this.getLogisticsInfo()
  },
  methods: {
    getLogisticsInfo () {
      if (!this.logisticsCompanyCode) {
        this.list = []
        return
      }
      const params = {
        logisticsCompanyCode: this.logisticsCompanyCode, // 非物流的解决报错问题
        logisticsNumber: this.logisticsNumber,
        phone: this.phone || undefined
      }
      this.$http
        .get('/help/consumer/logisticsCompany/getLogisticsInfo', { params })
        .then(({ data: res }) => {
          if (res.result) {
            this.list = res.data || []
          } else {
            this.list = []
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  padding-left: 38px;
}
.list {
  padding-top: 10px;
  max-height: 400px;
  overflow: auto;
  .item {
    display: flex;
    padding: 4px 0;
    .time {
      width: 130px;
      color: #797979;
    }
    .context {
      flex: 1;
      color: #303133;
      padding-left: 12px;
    }
  }
}
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #797979;
  border: 1px solid #e5e5e5;
  height: 100px;
}
</style>
